import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import logo from '../img/Header/logo.png';
import classes from '../Header/Header.module.scss';

function Header() {
  const { i18n } = useTranslation();
  const currentLanguage = (i18n.language || 'en').split('-')[0];

  function toggle() {
    let x = document.getElementById("myTopnav");
    if (x.className === classes.topnav) {
      x.className += ` ${classes.responsive}`;
    } else {
      x.className = classes.topnav;
    }
  }

  return (
    <header>
      <div className={classes['menu-flex']}>

        {/* Logo */}
        <div>
          <Link to={currentLanguage === 'es' ? "/es" : "/en"}>
            <img
              src={logo}
              alt="Backend Helpers logo"
              className={classes['img-logo']}
            />
          </Link>
        </div>

        {/* Menú */}
        <div className={classes['menu-flex']}>
          <nav className={classes.topnav} id="myTopnav">

            <Link to={currentLanguage === 'es' ? "/es/products" : "/en/products"}>
              {currentLanguage === 'es' ? 'Productos' : 'Products'}
            </Link>

            <Link to={currentLanguage === 'es' ? "/es/historias-exito" : "/en/success-stories"}>
              {currentLanguage === 'es' ? 'Historias de éxito' : 'Success Stories'}
            </Link>

            <Link to="https://blog.backendhelpers.co/" target="_blank">
              Blog
            </Link>

            <Link
              className={classes['contact-link']}
              to={currentLanguage === 'es' ? "/es/contacto" : "/en/contact"}
            >
              {currentLanguage === 'es' ? 'Contáctanos' : 'Get in Touch'}
            </Link>

            <button type="button" className={classes.icon} onClick={toggle}>
              <i className="fa fa-bars" aria-hidden="true"></i>
            </button>

          </nav>
        </div>
      </div>
    </header>
  );
}

export default Header;
